import React from 'react';

import { Typography } from '@mui/material';

import Chip from '../../../../components/Chip';
import ContentCard from '../../../../components/ContentCard';
import DataGrid from '../../../../components/DataGrid';
import { Class } from '../../../../services/classes/types';
import { MAX_CLASS_SIZE } from '../../../../utils/common/constants';
import { StudentsHeadingWrapper } from '../../index.styles';

interface StudentsCardProps {
  classObj: Class;
}

const StudentsCard = ({ classObj }: StudentsCardProps) => (
  <ContentCard
    variant="outlined"
  >
    <StudentsHeadingWrapper>
      <Typography variant="h6">Students</Typography>
      <Chip
        label={`${classObj?.studentCount} / ${MAX_CLASS_SIZE}`}
        variant="outlined"
        size="small"
      />
    </StudentsHeadingWrapper>
    <DataGrid
      columns={[
        {
          field: 'name',
          headerName: 'Name',
          width: 200,
        },
        {
          field: 'school',
          headerName: 'School',
          width: 200,
        },
      ]}
      getRowId={(row) => row.studentId}
      rows={classObj?.students ?? []}
    />
  </ContentCard>
);
export default StudentsCard;
